import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const SsaiAgentRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/ai-agent', { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white text-gray-600">
      <p>Redirecting to the AI Agent…</p>
    </div>
  );
};

export default SsaiAgentRedirect;
